export const login = {
  "Mais facilidade na sua vida!": "Más facilidad en tu vida!",
  "Nós facilitamos o seu ponto e seus benefícios para": "Facilitamos tu registro de tiempo y beneficios para que",
  "você focar no que realmente": "te centres en lo que realmente",
  "importa!": "importa!",
  "O aplicativo MarQPonto está disponível para Android e iOS": "La aplicación MarQPonto está disponible para Android e iOS",
  "Colaborador": "Empleado",
  "Login": "Iniciar sesión",
  "Informe o seu e-mail para recuperar sua senha": "Ingresa tu correo electrónico para recuperar tu contraseña",
  "Esqueci minha senha": "Olvidé mi contraseña",
  "Entrar": "Entrar",
  "Eu sei minha senha": "Sé mi contraseña",
  "Recuperar": "Recuperar",
  "Aviso": "Aviso",
  "Usuário não encontrado no sistema.Se estiver tentando logar com seu e-mail, revise os dados e tente novamente.Se preferir, você também pode logar usando seu CPF.": "Usuario no encontrado en el sistema.Si está intentando iniciar sesión con su correo electrónico, revise los datos e inténtelo de nuevo.Si lo prefiere, también puede iniciar sesión con su CPF.",
  "Usuário não encontrado no sistema.Se estiver tentando logar com CPF, revise os dados e tente novamente.Você também pode logar usando seu e-mail.": "Usuario no encontrado en el sistema.Si está intentando iniciar sesión con CPF, revise los datos e inténtelo de nuevo.También puede iniciar sesión con su correo electrónico.",
  "Você precisa preencher o Captcha para fazer login no sistema.": "Necesita completar el Captcha para iniciar sesión en el sistema.",
  "Sucesso!": "¡Éxito!"
};


// WEBPACK FOOTER //
// ./src/resources/es/login.js